import { css } from 'styled-components';
import { margin } from './margin';
import { padding } from './padding';
export const space = css `
  ${margin}
  ${padding}
`;
